<template>
  <div>
    <div
      class="number_card_container"
      :class="{'pointer':routeLinkPath}"
    >
      <div
        class="number_card"
        :class="localCustomClass"
        v-for="item in leftNumArr"
      >
        <div class="linear_number">
          <countTo
            :startVal='startVal'
            :endVal='item'
            :duration='3000'
            :autoplay="true"
            :decimals="decimals"
          ></countTo>
        </div>
      </div>
      <div
        v-if="rightNumArr.length>0"
        class="decimal_number_card"
      >
        <div
          class="number_card_split"
          :class="localCustomClass"
        >.</div>
        <div
          class="number_card"
          :class="localCustomClass"
          v-for="item in rightNumArr"
        >
          <div class="linear_number">
            <countTo
              :startVal='startVal'
              :endVal='item'
              :duration='3000'
              :autoplay="true"
              :decimals="decimals"
            ></countTo>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import countTo from "vue-count-to"

  export default {
    name: "numberDigitalFlop",
    components: {
      countTo,
    },
    props: {
      danWei: {
        type: String,
      },
      num: {
        type: Number,
      },
      // customClass可选值 'blue','yellow','green'，对应蓝色、黄色、绿色字体和背景图
      customClass: {
        type: String,
        default: "blue",
      },
      routeLinkPath: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        startVal: 0,
        endVal: 0,
        decimals: 0,
        suffix: "", // 单位
        leftNumArr: [],
        rightNumArr: [],
        localCustomClass: "blue",
      };
    },
    watch: {
      num() {
        this.init();
      },
    },
    mounted() {
      setTimeout(() => {
        this.init();
        this.localCustomClass = this.customClass;
      }, 500);
    },
    methods: {
      init() {
        this.setNumber();
      },
      setNumber() {
        let numStr = JSON.stringify(this.num||0);
        let leftNumArr = [];
        let rightNumArr = [];
        if (numStr.indexOf(".") > -1) {
          leftNumArr = numStr.split(".")[0].split("");
          rightNumArr = numStr.split(".")[1].split("");
        } else {
          leftNumArr = numStr.split("");
        }
        // leftNumArr.forEach(item=>{
        //   item = JSON.parse(item)
        // })
        for (let i = 0; i < leftNumArr.length; i++) {
          const element = leftNumArr[i];
          leftNumArr[i] = JSON.parse(element);
        }
        for (let i = 0; i < rightNumArr.length; i++) {
          const element = rightNumArr[i];
          rightNumArr[i] = JSON.parse(element);
        }
        // rightNumArr.forEach(item=>{
        //   item = JSON.parse(item)
        // })
        this.leftNumArr = leftNumArr;
        this.rightNumArr = rightNumArr;
      },
      setNumberUnit() {
        this.startVal = this.endVal;
        if (this.num || this.num == 0) {
          this.suffix = this.danWei;
          if (this.num.toFixed(0).length < 5) {
            this.endVal = this.num;
            this.decimals = 0;
            this.suffix = this.danWei;
          } else if (
            this.num.toFixed(0).length >= 5 &&
            this.num.toFixed(0).length < 9
          ) {
            this.endVal = Number(this.num / 10000);
            this.decimals = 2;
            this.suffix = "万" + this.danWei;
          } else if (this.num.toFixed(0) >= 9) {
            this.endVal = Number(this.num / 100000000);
            this.decimals = 2;
            this.suffix = "亿" + this.danWei;
          }
        }
      },
    },
  };
</script>

<style scoped lang="less">
  .number_card_container {
    white-space: nowrap;
    &.pointer{
      cursor: pointer;
    }
    .number_card {
      display: inline-block;
      font-size: 24px;
      padding: 10px;
      font-weight: bold;
      text-align: center;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      margin-right: 4px;
      .linear_number {
        width: 100%;
        height: 100%;
        line-height: 46px;
      }
      &.blue {
        background-image: url("../../../../static/img/numberBg.png");
        .linear_number {
          color: transparent;
          background: linear-gradient(to bottom, #aef5ff, #00deff);
          -webkit-background-clip: text;
        }
      }
      &.yellow {
        .linear_number {
          color: transparent;
          background: linear-gradient(to bottom, #fff5c8, #fcd520);
          -webkit-background-clip: text;
        }
      }
      &.green {
        .linear_number {
          color: transparent;
          background: linear-gradient(to bottom, #aefff6, #00ff8a);
          -webkit-background-clip: text;
        }
      }
    }
    .decimal_number_card {
      display: inline-block;
      .number_card_split {
        display: inline-block;
        vertical-align: bottom;
        font-weight: bold;
        font-size: 24px;
        &.blue {
          color: #00deff;
        }
        &.yellow {
          color: #fcd520;
        }
        &.green {
          color: #00ff8a;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/NumberFlop.vue